import React from "react";
import { useField, useFormikContext } from "formik";
import PhoneInput from 'react-phone-number-input/input'

const FormikPhone = ({ ...props }) => {
  const [field,meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  return (
    <div className="field-container">
      <div className="error-container"><em>*</em>{meta.touched && meta.error && <div className="error">{meta.error}</div>}</div>
    <PhoneInput
      {...field}
      {...props}
      placeholder="Phone Number (US and Canada only)"
      onChange={val => {
        setFieldValue(field.name, val);
      }}
      country='US'
    />
    </div>
  );
};

export default FormikPhone;